<template>
  <div class="deposit">
    <div style="text-align: center">
      <div class="col-7" style="background-color: #fff; margin: 0 auto;">
        <div class="tab_box">
          <div v-for="(item,index) in tabList" :key="index">
            <div :class="[isActive==item.id?'active':'']" @click="handleTab(item.id)">{{item.name}}</div>
          </div>
        </div>
        <div class="goods_box">
          <div class="image_box">
            <img src="../../static/img/gift.png"/>
          </div>
          <div class="item_box">
            <div class="title_box">
             <p> {{isActive==0?'新人礼包':"钻石礼包"}}</p>
            </div>
            <div class="price_box">
              <p>现价：<em>¥</em><span>{{isActive==0?'19.00':"299.00"}}</span></p>
            </div>
            <div class="spec_box">
              <p>规格：</p><div style="border:1px solid red;color:red;padding:0px 2px">常规</div>
            </div>
            <div class="num_box">
              <p>数量：<span>1</span></p>
            </div>
            <div class="phone_box">
              <p>账号：</p><input type="text"/>
            </div>
            <div class="phone_box">
              <p>支付方式：</p>
            </div>
            <div class="pay_box">
             <div class="col-5" style="margin-right:20px;">
            <input type="radio" class="btn-check" id="wechat" autocomplete="off" name="selectPayWay">
            <label  class="btn border" for="wechat" :style="{ color: payWay==='wechat' ? '#2383f1' : '#000', width: '100%',borderColor : payWay==='wechat' ? '#2383f1 !important' : '#999999 !important',paddingTop: '0.8rem',fontSize : 1*windowWidth/100+'px' }" @click="payWaySelect('wechat')"><img class="wechatimg rounded"/>   <strong>微信支付</strong></label>
            <div class="radio-btn-cheaked" :style="{ visibility: payWay==='wechat' ? 'visible' : 'hidden' }"></div>
          </div>
          <div class="col-5">
            <input type="radio" class="btn-check" id="alipay" autocomplete="off" name="selectPayWay">
            <label class="btn border radio-btn" for="alipay" :style="{ color: payWay==='alipay' ? '#2383f1' : '#000', width: '100%',borderColor : payWay==='alipay' ? '#2383f1 !important' : '#999999 !important',paddingTop: '0.8rem',fontSize : 1*windowWidth/100+'px' }" @click="payWaySelect('alipay')"><img class="alipayimg rounded"/>   <strong>支付宝支付</strong></label>
            <div class="radio-btn-cheaked" :style="{ visibility: payWay==='alipay' ? 'visible' : 'hidden' }"></div>
            </div>
            </div>
            <div class="btn_box">
          <button type="button" class="btn btn-primary btn-lg" :style="{backgroundColor:'#f05a64', borderColor:'#f05a64',width: '40%',fontSize : 1*windowWidth/100+'px'}">立即购买</button>
            </div>
          </div>
        </div>
        <div class="tab_box" style="margin-top:100px">
          <div :class="[isActivee==0?'active':'']">商品详情</div>
        </div>
        <div class="detail_box"> 
          {{isActive==0?"礼包内含：168颗钻石、6个棒棒糖和6支康乃馨花朵":"礼包内含：3888颗钻石"}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Deposit",
  data() {
    return {
      data: [],
      isActive:0,
      isActivee:0,
      tabList: [
        {
          id: 0,
          name: "新人礼包"
        },
        {
          id: 1,
          name: "钻石礼包"
        },
      ],
      goodsList:[],
      money: 0,
      payWay: "",
      windowWidth: 1920,
    };
  },
  methods: {
    handleTab(e){
      this.isActive=e
    },
    moneySelect (money) {
      this.money = money
    },
    payWaySelect (payWay) {
      this.payWay = payWay
    }
    // loadimg: function () {
    //   this.$http
    //     .get("http://74.120.171.191:8086/picture/pixiv")
    //     .then((response) => {
    //       console.log(response);
    //       if (response.data.code === 200) {
    //         console.log("run----------------------------------------------");
    //         let index = 0;
    //         let count = 3;
    //         let arrTemp = [];
    //         let experts = response.data.data.list;
    //         for (let i = 0; i < experts.length; i++) {
    //           index = parseInt(i / count);
    //           if (arrTemp.length <= index) {
    //             arrTemp.push([]);
    //           }
    //           arrTemp[index].push(experts[i]);
    //         }
    //         this.data = arrTemp;
    //         console.log(this.data);
    //       }
    //     });
    // },
    // moneySelect: function (money) {
    //   this.money = money;
    // },
    // payWaySelect: function (payWay) {
    //   this.payWay = payWay;
    // },
  },
  // mounted() {
  //   this.windowWidth = document.body.clientWidth;
  // },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: #f05a64;
}

.tips_front {
  font-size: 1.3rem;
}

.radio-btn-cheaked {
  border-color: #f05a64 !important;
  width: 1rem;
  height: 1rem;
  background-image: url("../../static/img/icon_select.png");
  background-size: 100% 100%;
  margin-top: -1rem;
  float: right;
  position: relative;
}

.wechatimg {
  width: 1.3rem;
  height: 1.3rem;
  background-image: url("../../static/img/icon_wechat.png");
  background-size: 100% 100%;
  max-width: 50%;
  max-height: 50%;
}

.alipayimg {
  width: 1.3rem;
  height: 1.3rem;
  background-image: url("../../static/img/icon_alipay.png");
  background-size: 100% 100%;
  max-width: 50%;
  max-height: 50%;
}

.moneyFont {
  color: #999;
  font-size: 0.8rem;
  margin: 0;
}
.tab_box {
  width: 100%;
  height: 47px;
  border: 1px solid #d7d7d7;
  display: flex;
  justify-content: left;
}
.active{
  background-color: #f05a64!important;
  color: #fff;
}
.tab_box div {
  width: 100px;
  line-height: 45px;
  border-right:1px solid #d7d7d7 ;
}
.goods_box{
  margin-top: 10px;
  /* border: 1px solid red; */
  display: flex;
  box-sizing: border-box;
  padding: 20px 20px 40px 20px;
}
.image_box{
  width: 40%;
}
.image_box img{
  width: 300px;
  height: 300px;
}
.item_box{
  width: 59%;
 /* border: 1px solid red; */
 margin-left: 40px;
 display: flex;
 flex-direction: column;
}
.title_box{
  font-family: "微软雅黑","宋体";
  font-size: 28px;
  color: #000;
  font-weight: bold;
  text-align: left;
}
.price_box{
  display: flex;
  align-items: left;
  justify-content: left;
  font-size: 14px;
  margin-top: 20px;

}
.price_box span{
  font-size: 28px;
  color: #000;
  font-weight: bold;
}
.price_box em{
  font-style: normal;
  color: #000;
  font-weight: bold;
}
.spec_box{
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-top: 20px;
}
.num_box{
  display: flex;
  margin-top: 20px;
  font-size: 14px;
}
.phone_box{
  display: flex;
  align-items: center;
  margin-top: 20px;
  font-size: 14px;
}
.phone_box input{
  outline: none;
}
.pay_box{
  display: flex;
  margin-top: 20px;
}
.btn_box{
  display: flex;
  margin-top: 30px;
}
.detail_box{
  display: flex;
  box-sizing: border-box;
  padding:10px 10px 100px 10px;
  border-bottom: 1px solid #d7d7d7;
  border-left: 1px solid #d7d7d7;
  border-right: 1px solid #d7d7d7;
  color: #000;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Deposit.vue